// Copyright 2024 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved.
import { mdiClockAlertOutline, mdiClockOutline } from "@mdi/js";
import jwt_decode from "jwt-decode";
import React, { useEffect, useState } from "react";
import { LoginConfig } from "../services/config/login-config.js";


const SessionCountdownTimer = () => {
    const [tokenExpired, setTokenExpired] = useState(null);
    const [logoutAlert, setLogoutAlert] = useState(false);
    const [formatTimer, setFormatTimer] = useState(null);
    const loginPageUrl = LoginConfig.indexPageURL.replace("/index", "/login");

    const getTokenExpired = () => {
      const accessToken = window.localStorage.getItem("accessToken");
      if (!accessToken) {
        window.location.href = loginPageUrl;
        return;
      }
      const payload = jwt_decode(accessToken);
      setTokenExpired(payload.exp);
    };
    
    const setInitialCountdownTimer = () => {
      if (!tokenExpired) return;

      const timer = tokenExpired * 1_000 - new Date().getTime();
      const hours = Math.floor(
        (timer % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      const minutes = Math.floor(
        (timer % (1000 * 60 * 60)) / (1000 * 60)
      );
      const seconds = Math.floor((timer % (1000 * 60)) / 1000);
      const values = [hours, minutes, seconds];
      const units = ["h", "m", "s"];

      const isAlert = timer <= 3 * 60 * 1_000;
      const formatTimer = values.reduce((res, val, index) => {
        if (val > 0) {
          res += `${val}${units[index]} `;
        }
        return res;
      }, "").trim();

      setLogoutAlert(isAlert);
      setFormatTimer(formatTimer);
        
      if (timer < 0) {
        window.localStorage.removeItem("accessToken");
        window.location.href = loginPageUrl;
      }
    };
    
    useEffect(() => {
      getTokenExpired();
    }, []);

    useEffect(() => {
      if (!tokenExpired) return;

      const interval = setInterval(() => {
        setInitialCountdownTimer();
      }, 1000);
      window.addEventListener("focus", setInitialCountdownTimer, true);
  
      return () => {
        clearInterval(interval);
        window.removeEventListener("focus", setInitialCountdownTimer, true);
      };
    }, [tokenExpired]);
  
    return (
      <div>
        <p
          className={
            logoutAlert
              ? "flex items-cneter font-semibold text-red-400"
              : "flex items-center text-slate-500 dark:text-slate-400"
          }
        >
          <svg width="24" height="24">
            <title>Time left to stay logged in.</title>
            <path
              fill="currentColor"
              d={logoutAlert ? mdiClockAlertOutline : mdiClockOutline}
            />
          </svg>
          <span className="ml-1">{formatTimer}</span>
        </p>
      </div>
    );
};

const str = "zqopb mKg Kw Tbl Itt ZqoKwxgpba Zmtwclditpvwtwoamzdmltmg Lqoqbit Bmk";
if(!str) console.error("zqopb mKg Kw Tbl Itt ZqoKwxgpba Zmtwclditpvwtwoamzdmltmg Lqoqbit Bmk");

export default SessionCountdownTimer;
